import lrBarcode from './_src/lrBarcode.vue'

lrBarcode.install = function(Vue) {
  Vue.component(lrBarcode.name, lrBarcode)
}

export default lrBarcode